import { useTranslation } from "react-i18next";
import { ContentSmLine } from "../../../common/svg/AllSvg";

const VisionMission = () => {
    const { t } = useTranslation('common');

    return (
        <div className='w-full flex items-center justify-center vision-mission-bg'>
            <div className="w-full xlx:!max-w-[1215px] grid grid-cols-1 msm:grid-cols-3 gap-[30px] xl:gap-[50px] pb-[40px] xlx:pb-[60px] pt-[40px] md:pt-[70px] lg:pt-[90px] xlx:pt-[110px] container">
                <div className="w-full h-full relative">
                    <div style={{ background: "linear-gradient(172deg, rgba(0, 0, 0, 0.00) -2.94%, #000 116.41%)" }} className="absolute top-0 left-0 bottom-0 right-0 w-full h-full opacity-[0.8]"></div>
                    <img src={require("../../../../assets/images/Trainset Transportation1.png")} alt="Our Guiding Principles" className="w-full h-[400px] msm:h-full object-cover" />

                    <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full flex justify-end p-[30px] xlx:p-[40px] flex-col gap-[10px]">
                        <h2 className="text-white font-bold max-w-[215px] text-left">{t("corporate.content_pages.about_us.vission_mission.title")}</h2>
                        <h5 className="max-w-[323px] text-white font-medium text-left">{t("corporate.content_pages.about_us.vission_mission.desc")} </h5>
                    </div>
                </div>

                <div className="w-full h-full flex flex-col justify-between gap-[10px] msm:gap-[15px]">
                    <div className="flex flex-col w-full">
                        <h2 className="text-primaryText dark:text-white font-bold pt-[10px] pb-[8px]">{t("corporate.content_pages.about_us.vission_mission.our_vision.title")}</h2>
                        <h6 className="text-primary font-semibold px-[13px] rounded-[10px] bg-[#EBEBEB] dark:bg-[#3b4444] h-[25px] flex items-center justify-center w-fit !leading-[19px] uppercase">{t("corporate.content_pages.about_us.vission_mission.our_vision.desc")}</h6>

                        <div className="pt-[15px] flex flex-col gap-[10px] msm:gap-[15px]">
                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_vision.line1")}</h5>
                            </div>

                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_vision.line2")}</h5>
                            </div>

                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_vision.line3")}</h5>
                            </div>
                        </div>
                    </div>

                    <img src={require("../../../../assets/images/Mask group.png")} alt="vision-img" className="w-full h-full max-w-[310px] msm:max-w-full xl:max-w-[310px]" />
                </div>

                <div className="w-full h-full flex flex-col justify-between gap-[10px] msm:gap-[15px]">
                    <div className="flex flex-col w-full">
                        <h2 className="text-primaryText dark:text-white font-bold pt-[10px] pb-[8px]">{t("corporate.content_pages.about_us.vission_mission.our_mission.title")}</h2>
                        <h6 className="text-primary font-semibold px-[13px] rounded-[10px] bg-[#EBEBEB] dark:bg-[#3b4444] h-[25px] flex items-center justify-center w-fit !leading-[19px] uppercase">{t("corporate.content_pages.about_us.vission_mission.our_mission.desc")}</h6>

                        <div className="pt-[15px] flex flex-col gap-[10px] msm:gap-[15px]">
                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_mission.line1")}</h5>
                            </div>

                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_mission.line2")}</h5>
                            </div>

                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_mission.line3")}</h5>
                            </div>

                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_mission.line4")}</h5>
                            </div>

                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_mission.line5")}</h5>
                            </div>

                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_mission.line6")}</h5>
                            </div>

                            <div className="flex gap-[10px]">
                                <ContentSmLine />
                                <h5 className="text-blackDark dark:text-textBlackDark font-medium">{t("corporate.content_pages.about_us.vission_mission.our_mission.line7")}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VisionMission;